let pricingMap = {
  SINGAPORE: {
    currency: "SG$",
    price: 130,
    cost: 6.30
  },
  "UNITED ARAB EMIRATES": {
    currency: "AED",
    price: 365,
    cost: 17.50
  },
  "UNITED KINGDOM": {
    currency: "£",
    price: 75,
    cost: 4.00
  },
  "NEW ZEALAND": {
    currency: "NZ$",
    price: 165,
    cost: 8.00
  },
  CANADA: {
    currency: "CA$",
    price: 135,
    cost: 6.70
  },
  AUSTRALIA: {
    currency: "AU$",
    price: 150,
    cost: 7.50
  },
  "UNITED STATES": {
    currency: "$",
    price: 99,
    cost: 4.95
  },
  CYPRUS: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  ESTONIA: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  FINLAND: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  FRANCE: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  GERMANY: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  IRELAND: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  ITALY: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  LATVIA: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  LITHUANIA: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  LUXEMBOURG: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  MALTA: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  NETHERLANDS: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  PORTUGAL: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  "SAN MARINO": {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  SLOVAKIA: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  SLOVENIA: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  SPAIN: {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  "VATICAN CITY": {
    currency: "€",
    price: 84,
    cost: 4.75
  },
  REST: {
    currency: "$",
    price: 99,
    cost: 4.75
  },
};

document.addEventListener("DOMContentLoaded", function () {
  let freeShippingPrices = document.getElementsByClassName(
    "free_shipping_price"
  );
  let freeShippingCosts = document.getElementsByClassName(
    "free_shipping_cost"
  );
  if (freeShippingPrices || freeShippingCosts) {
    fetch("https://robify.ezapp.ovh/country?justcountry=1")
      .then((response) => response.text())
      .then((country) => {
        try {
          let countryProcessed = country.split(", ");
          countryProcessed = countryProcessed[0].split(" (");
          const updatedPricing = pricingMap[countryProcessed[0]] || pricingMap["REST"];
          for (let i = 0; i < freeShippingPrices.length; i++) {
            freeShippingPrices[i].innerText =
              updatedPricing.currency + updatedPricing.price;
          }
          for (let i = 0; i < freeShippingCosts.length; i++) {
            freeShippingCosts[i].innerText =
              updatedPricing.currency + updatedPricing.cost;
          }
        } catch (e) {
          console.error("Unable to update free shipping pricing:", e);
        }
      });
  }
});
